module.exports = __webpack_public_path__ + "img/live-cast.fbb8ee23.png";